import Cookies from 'js-cookie';

export const isAdminSession = () => {
  const adminJwt = Cookies.get('adminjwt');
  return adminJwt !== undefined && adminJwt != '';
};
